import { takeLatest } from "redux-saga/effects"
import {
  createWineClubMemberships,
  uploadBenefitsImage,
  uploadMembershipImage,
  getExistingBenefits,
  getTriviaCategories,
  uploadTastingNotesWineImage,
  uploadTastingNotesFlavourImage,
  createTastingNotes,
  editTastingNotes,
  deleteBenefit,
  getTastingNotesWeekList,
  getTastingNotesData,
  deleteTastingNote,
  uploadTriviaCategoryImage,
  createTriviaCategories,
  getWineBenefitData,
  uploadBenefitIconImage,
  editWineBenefits,
  updateTriviaCategories,
  getMembershipImageURL,
  uploadGrandCruThumbnail,
  uploadGrandCruVideo,
  getGrandCruGoals,
  updateGrandCruGoals,
  getGrandCruVideoData,
  updateGrandCruVideo,
  uploadTastingNotesVideoThumbnail,
  uploadVideoGalleryThumbnail,
  uploadVideoGalleryVideo,
  getVideoGalleryVideos,
  deleteVideoGalleryVideo,
  getRoundsList,
  getViewRoundData,
  createRound,
  deleteRound,
  getRoundData,
  updateRound,
  getHolidays,
  getVideoLibraryVideos,
  getAssignVideosWeekData,
  assignVideos,
  roundStatusUpdate,
  uploadHolidayList,
  getImportPreviousRounds,
  getBeverage,
  editWineRegionCategory,
  addWineRegionCategory,
  getDMVWineRegionList,
  deleteWineRegionMenuCategory,
  addDMVWineMenuItems,
  getDMVWineItems,
  updateDMVWineItems,
  deleteDMVWineMenuItem,
  editBeverageCategory,
  addBeverageCategory,
  deleteBeverageCategory,
  addDMVBeverageMenuItems,
  getDMVBeverageItems,
  updateDMVBeverageItems,
  deleteDMVBeverageMenuItem,
  getDMVAutoSuggestQuestions,
  editDMVAutoSuggestedQuestion,
  getGenerateQuestionDMVWineRegion,
  getGenerateQuestionDMVBeverage,
  editSpiritCategory,
  addSpiritCategory,
  deleteSpiritCategory,
  getDMVSpiritSubMenuist,
  getSpirit,
  getDMVSpiritItems,
  addDMVSpiritMenuItems,
  updateDMVSpiritItems,
  deleteDMVSpiritMenuItem,
  getGenerateQuestionDMVSpirits,
  getImportSpirit,
  addDMVSpiritSubMenuist,
  getDMVSpiritSummary
} from "./user"
import {
  createWineClubMembershipsAction,
  uploadBenefitsImageAction,
  uploadMembershipImageAction,
  getExistingBenefitsAction,
  getTriviaCategoriesAction,
  uploadTastingNotesWineImageAction,
  uploadTastingNotesFlavourImageAction,
  createTastingNotesAction,
  deleteBenefitAction,
  getTastingNotesWeekListAction,
  getTastingNotesDataAction,
  deleteTastingNoteAction,
  uploadTriviaCategoryImageAction,
  createTriviaCategoriesAction,
  editTastingNotesAction,
  getWineBenefitDataAction,
  uploadBenefitIconImageAction,
  editWineBenefitsAction,
  updateTriviaCategoriesAction,
  getMembershipImageURLAction,
  uploadGrandCruThumbnailAction,
  uploadGrandCruVideoAction,
  getGrandCruGoalsAction,
  updateGrandCruGoalsAction,
  getGrandCruVideoDataAction,
  updateGrandCruVideoAction,
  uploadTastingNotesVideoThumbnailAction,
  uploadVideoGalleryThumbnailAction,
  uploadVideoGalleryVideoAction,
  getVideoGalleryVideosAction,
  deleteVideoGalleryVideoAction,
  getRoundsListAction,
  getViewRoundDataAction,
  createRoundAction,
  deleteRoundAction,
  getRoundDataAction,
  updateRoundAction,
  getHolidaysAction,
  getVideoLibraryVideosAction,
  getAssignVideosWeekDataAction,
  assignVideosAction,
  roundStatusUpdateAction,
  uploadHolidayListAction,
  getImportPreviousRoundsAction
} from "../actions/index"
import {
  addBeverageCategoryAction,
  addDMVBeverageMenuItemsAction,
  addDMVSpiritMenuItemsAction,
  addDMVWineMenuItemsAction,
  addSpiritCategoryAction,
  addWineRegionCategoryAction,
  deleteBeverageCategoryAction,
  deleteDMVBeverageMenuItemAction,
  deleteDMVSpiritMenuItemAction,
  deleteDMVWineMenuItemAction,
  deleteSpiritCategoryAction,
  deleteWineRegionMenuCategoryAction,
  editBeverageCategoryAction,
  editDMVAutoSuggestedQuestionAction,
  editSpiritCategoryAction,
  editWineRegionCategoryAction,
  getBeverageAction,
  getDMVAutoSuggestQuestionsAction,
  getDMVBeverageItemsAction,
  getDMVSpiritItemsAction,
  getDMVSpiritSubMenuistAction,
  getDMVWineItemsAction,
  getDMVWineRegionListAction,
  getGenerateQuestionDMVBeverageAction,
  getGenerateQuestionDMVSpiritsAction,
  getGenerateQuestionDMVWineRegionAction,
  getImportSpiritAction,
  getSpiritAction,
  updateDMVBeverageItemsAction,
  updateDMVSpiritItemsAction,
  updateDMVWineItemsAction,
  addDMVSpiritSubMenuistAction,
  getDMVSpiritSummaryAction
} from "../actions/user"

export default function* DMVActionWatcher() {
  yield takeLatest(createWineClubMembershipsAction, createWineClubMemberships)
  yield takeLatest(uploadBenefitsImageAction, uploadBenefitsImage)
  yield takeLatest(uploadMembershipImageAction, uploadMembershipImage)
  yield takeLatest(getExistingBenefitsAction, getExistingBenefits)
  yield takeLatest(getTriviaCategoriesAction, getTriviaCategories)
  yield takeLatest(uploadTastingNotesWineImageAction, uploadTastingNotesWineImage)
  yield takeLatest(uploadTastingNotesFlavourImageAction, uploadTastingNotesFlavourImage)
  yield takeLatest(createTastingNotesAction, createTastingNotes)
  yield takeLatest(deleteBenefitAction, deleteBenefit)
  yield takeLatest(getTastingNotesWeekListAction, getTastingNotesWeekList)
  yield takeLatest(getTastingNotesDataAction, getTastingNotesData)
  yield takeLatest(deleteTastingNoteAction, deleteTastingNote)
  yield takeLatest(uploadTriviaCategoryImageAction, uploadTriviaCategoryImage)
  yield takeLatest(createTriviaCategoriesAction, createTriviaCategories)
  yield takeLatest(editTastingNotesAction, editTastingNotes)
  yield takeLatest(getWineBenefitDataAction, getWineBenefitData)
  yield takeLatest(uploadBenefitIconImageAction, uploadBenefitIconImage)
  yield takeLatest(editWineBenefitsAction, editWineBenefits)
  yield takeLatest(updateTriviaCategoriesAction, updateTriviaCategories)
  yield takeLatest(getMembershipImageURLAction, getMembershipImageURL)
  yield takeLatest(uploadGrandCruThumbnailAction, uploadGrandCruThumbnail)
  yield takeLatest(uploadGrandCruVideoAction, uploadGrandCruVideo)
  yield takeLatest(getGrandCruGoalsAction, getGrandCruGoals)
  yield takeLatest(updateGrandCruGoalsAction, updateGrandCruGoals)
  yield takeLatest(getGrandCruVideoDataAction, getGrandCruVideoData)
  yield takeLatest(updateGrandCruVideoAction, updateGrandCruVideo)
  yield takeLatest(uploadTastingNotesVideoThumbnailAction, uploadTastingNotesVideoThumbnail)
  yield takeLatest(uploadVideoGalleryThumbnailAction, uploadVideoGalleryThumbnail)
  yield takeLatest(uploadVideoGalleryVideoAction, uploadVideoGalleryVideo)
  yield takeLatest(getVideoGalleryVideosAction, getVideoGalleryVideos)
  yield takeLatest(deleteVideoGalleryVideoAction, deleteVideoGalleryVideo)
  yield takeLatest(getRoundsListAction, getRoundsList)
  yield takeLatest(getViewRoundDataAction, getViewRoundData)
  yield takeLatest(createRoundAction, createRound)
  yield takeLatest(deleteRoundAction, deleteRound)
  yield takeLatest(getRoundDataAction, getRoundData)
  yield takeLatest(updateRoundAction, updateRound)
  yield takeLatest(getHolidaysAction, getHolidays)
  yield takeLatest(getVideoLibraryVideosAction, getVideoLibraryVideos)
  yield takeLatest(getAssignVideosWeekDataAction, getAssignVideosWeekData)
  yield takeLatest(assignVideosAction, assignVideos)
  yield takeLatest(roundStatusUpdateAction, roundStatusUpdate)
  yield takeLatest(uploadHolidayListAction, uploadHolidayList)
  yield takeLatest(getImportPreviousRoundsAction, getImportPreviousRounds)
  yield takeLatest(getDMVWineRegionListAction, getDMVWineRegionList)
  yield takeLatest(getBeverageAction, getBeverage)
  yield takeLatest(editWineRegionCategoryAction, editWineRegionCategory)
  yield takeLatest(addWineRegionCategoryAction, addWineRegionCategory)
  yield takeLatest(deleteWineRegionMenuCategoryAction, deleteWineRegionMenuCategory)
  yield takeLatest(addDMVWineMenuItemsAction, addDMVWineMenuItems)
  yield takeLatest(getDMVWineItemsAction, getDMVWineItems)
  yield takeLatest(updateDMVWineItemsAction, updateDMVWineItems)
  yield takeLatest(deleteDMVWineMenuItemAction, deleteDMVWineMenuItem)
  yield takeLatest(editBeverageCategoryAction, editBeverageCategory)
  yield takeLatest(addBeverageCategoryAction, addBeverageCategory)
  yield takeLatest(deleteBeverageCategoryAction, deleteBeverageCategory)
  yield takeLatest(addDMVBeverageMenuItemsAction, addDMVBeverageMenuItems)
  yield takeLatest(getDMVBeverageItemsAction, getDMVBeverageItems)
  yield takeLatest(updateDMVBeverageItemsAction, updateDMVBeverageItems)
  yield takeLatest(deleteDMVBeverageMenuItemAction, deleteDMVBeverageMenuItem)
  yield takeLatest(getDMVAutoSuggestQuestionsAction, getDMVAutoSuggestQuestions)
  yield takeLatest(editDMVAutoSuggestedQuestionAction, editDMVAutoSuggestedQuestion)
  yield takeLatest(getGenerateQuestionDMVWineRegionAction, getGenerateQuestionDMVWineRegion)
  yield takeLatest(getGenerateQuestionDMVBeverageAction, getGenerateQuestionDMVBeverage)
  yield takeLatest(editSpiritCategoryAction, editSpiritCategory)
  yield takeLatest(addSpiritCategoryAction, addSpiritCategory)
  yield takeLatest(deleteSpiritCategoryAction, deleteSpiritCategory)
  yield takeLatest(getDMVSpiritSubMenuistAction, getDMVSpiritSubMenuist)
  yield takeLatest(getSpiritAction, getSpirit)
  yield takeLatest(getDMVSpiritItemsAction, getDMVSpiritItems)
  yield takeLatest(addDMVSpiritMenuItemsAction, addDMVSpiritMenuItems)
  yield takeLatest(updateDMVSpiritItemsAction, updateDMVSpiritItems)
  yield takeLatest(deleteDMVSpiritMenuItemAction, deleteDMVSpiritMenuItem)
  yield takeLatest(getGenerateQuestionDMVSpiritsAction, getGenerateQuestionDMVSpirits)
  yield takeLatest(getImportSpiritAction, getImportSpirit)
  yield takeLatest(addDMVSpiritSubMenuistAction, addDMVSpiritSubMenuist)
  yield takeLatest(getDMVSpiritSummaryAction, getDMVSpiritSummary)
}
